/**
 * Node.
 *
 * @param {any} value
 * @param {Node} next
 */
export default function Node(value, next) {
	this._value = value;
	this._next = next;
}
